import { autorun, runInAction } from "mobx";
import { TourPlaybackManager } from ".";

export class StepActionsFacade {
  private tourPlaybackManager: TourPlaybackManager;

  constructor(tourPlaybackManager: TourPlaybackManager) {
    this.tourPlaybackManager = tourPlaybackManager;
  }

  proceedNext() {
    this.tourPlaybackManager.handleProceedNextFromStep();
  }

  onStepOnTrackChanged(stepId: string, callback: (isOnTrack: boolean) => void): () => void {
    return autorun(() => {
      const isOnTrack = this.tourPlaybackManager.isStepOnTrack(stepId);
      runInAction(() => {
        callback(isOnTrack);
      });
    });
  }

  onTargetElementChange(stepId: string, callback: (el: Element | null) => void): () => void {
    return autorun(() => {
      const element = this.tourPlaybackManager.getTargetElement(stepId);
      runInAction(() => {
        callback(element);
      });
    });
  }

  setCurrentTargetElement(el?: Element | null) {
    this.tourPlaybackManager.setCurrentTargetElement(el);
  }

  suspendTour() {
    this.tourPlaybackManager.suspendTour("userAction");
  }

  loadLastCheckpoint() {
    this.tourPlaybackManager.loadLastCheckpoint();
  }

  finishTour() {
    this.tourPlaybackManager.finishTour();
  }

  dismissTour() {
    this.tourPlaybackManager.dismissTour();
  }

  switchTour(guideId: string) {
    this.tourPlaybackManager.switchTour(guideId);
  }

  // To prevent circular reference in JSON.stringify
  toJSON() {
    return null;
  }
}

export class FlowHookActionsFacade {
  private tourPlaybackManager: TourPlaybackManager;

  constructor(tourPlaybackManager: TourPlaybackManager) {
    this.tourPlaybackManager = tourPlaybackManager;
  }

  finishTour() {
    this.tourPlaybackManager.finishTour();
  }

  loadLastCheckpoint() {
    this.tourPlaybackManager.loadLastCheckpoint();
  }

  // To prevent circular reference in JSON.stringify
  toJSON() {
    return null;
  }
}
